import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "Utils/Cards/Card";
import { ListadoMateriaPrima } from "./components/ListadoMateriaPrima";
import { loadConfiguracion } from "../../../../../../redux/modules/configuracion";
import "./styles/PesajeTraslado.css";

class PesajeTraslado extends Component {
    state = {
        traslado_id: null,
    };

    componentWillMount() {
        this.setState({ traslado_id: this.props.match.params.id });
    }

    regresar = () => {
        this.props.history.goBack();
    };

    refrescarPesajeAutomatico = () => {
        this.props.loadConfiguracion(false);
    };

    navigateToBoleta = () => {
        this.props.history.replace(
            `/traslados/${this.state.traslado_id}/ver-boleta`,
        );
    };

    navigateToRecepciones = (materiaPrimaId) => {
        if (materiaPrimaId) {
            this.props.history.push(
                `/traslados/${this.state.traslado_id}/edicion-recepciones/${materiaPrimaId}`,
            );
        } else {
            this.props.history.push(
                `/traslados/${this.state.traslado_id}/edicion-recepciones`,
            );
        }
    };

    render() {
        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <Card
                    icon="traslados_activo"
                    titulo="TRASLADO "
                    subtitulo="Recepciones"
                    noBorder
                >
                    <ListadoMateriaPrima
                        configuraciones={{
                            ...this.props.configuraciones,
                            loader: this.props.loader,
                        }}
                        user={this.props.user}
                        trasladoId={this.state.traslado_id}
                        regresar={this.regresar}
                        navigateToBoleta={this.navigateToBoleta}
                        refrescarPesajeAutomatico={
                            this.refrescarPesajeAutomatico
                        }
                        navigateToRecepciones={this.navigateToRecepciones}
                    />
                </Card>
            </div>
        );
    }
}

const mstp = (state) => {
    const configuraciones = state.configuracion.configuraciones;
    const loader = state.configuracion.loader;
    const user = state.login.me;

    return {
        configuraciones,
        loader,
        user,
    };
};

export default connect(mstp, { loadConfiguracion })(PesajeTraslado);
